<mat-select [formControl]="skjemakontroll"
            [compareWith]="erValgt"
            panelClass="varighet-minutter-velger--alternativer"
            class="e2e-stor-meny"
            [placeholder]="placeholder"
            panelWidth="250px"
            #varighetvelger>
  <mat-select-trigger>
    <span class="varighet">{{ skjemakontroll.value | duration }}</span>
    @if (skjemakontroll.value && starttidspunkt) {
      <span class="klokkeslett">({{'til {klokkeslett}'|translate: {klokkeslett: (valgtVarighetSomKlokkeslett() | plaintime)} }})</span>
    }
  </mat-select-trigger>
  <mat-option class="mat-option--skillelinje-under"><span>{{'ingen'|translate}} </span></mat-option>
  @for (varighet of varigheter; track varighet.antallMinutter) {
    <mat-option [value]="varighet.varighet">
      <span class="varighet">{{ varighet.varighet | duration }}</span>
      @if (varighet.klokkeslett) {
        <span class="klokkeslett">({{'til {klokkeslett}'|translate: {klokkeslett: (varighet.klokkeslett | plaintime)} }})</span>
      }
    </mat-option>
  }
</mat-select>
